// src/pages/Dashboard/components/Dialogs/NewCaseDialog.js

import React, { useState } from 'react';

/**
 * Dialog para criar novo caso
 * @param {boolean} isOpen - Se o dialog está aberto
 * @param {function} onClose - Callback ao fechar
 * @param {function} onCreate - Callback ao criar caso
 * @param {boolean} loading - Se está criando
 */
const NewCaseDialog = ({ isOpen, onClose, onCreate, loading }) => {
  const [nomeCaso, setNomeCaso] = useState('');
  const [codigoCliente, setCodigoCliente] = useState('');
  const [descricaoCaso, setDescricaoCaso] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!nomeCaso.trim() || !descricaoCaso.trim()) {
      alert('Nome e descrição são obrigatórios');
      return;
    }

    try {
      const success = await onCreate({
        nomeCaso,
        codigoCliente,
        descricaoCaso
      });

      if (success) {
        // Limpar campos
        setNomeCaso('');
        setCodigoCliente('');
        setDescricaoCaso('');
        onClose();
      }
    } catch (error) {
      alert(error.message || 'Erro ao criar caso');
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="dialog-overlay-dashboard" onClick={handleOverlayClick}>
      <div className="dialog-content-dashboard" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header-dashboard">
          <h3>Novo Caso</h3>
          <button className="dialog-close-dashboard" onClick={onClose}>×</button>
        </div>
        
        <div className="dialog-body-dashboard">
          <div className="form-group-dashboard">
            <label>Nome do Caso</label>
            <input
              type="text"
              value={nomeCaso}
              onChange={(e) => setNomeCaso(e.target.value)}
              placeholder="Digite o nome do caso"
              disabled={loading}
            />
          </div>
          
          <div className="form-group-dashboard">
            <label>Código do Cliente (opcional)</label>
            <input
              type="text"
              value={codigoCliente}
              onChange={(e) => setCodigoCliente(e.target.value)}
              placeholder="00000"
              disabled={loading}
            />
          </div>
          
          <div className="form-group-dashboard">
            <label>Descrição</label>
            <textarea
              value={descricaoCaso}
              onChange={(e) => setDescricaoCaso(e.target.value)}
              placeholder="Descreva o caso..."
              rows={5}
              disabled={loading}
            />
          </div>
        </div>
        
        <div className="dialog-footer-dashboard">
          <button onClick={onClose} disabled={loading}>
            Cancelar
          </button>
          <button onClick={handleSubmit} disabled={loading}>
            {loading ? 'Criando...' : 'Criar Caso'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewCaseDialog;